import swup from "../entrypoints/swup";

export default () => ({
  isShop: false,
  belowTheFold: false,
  animate: false,
  init() {
    let i = this;

    function scroll() {
      if (window.scrollY > window.innerHeight - 60) {
        i.belowTheFold = true;
      } else {
        i.belowTheFold = false;
      }
    }

    scroll();

    swup.hooks.on("visit:start", () => {
      i.closeMenu();
    });

    swup.hooks.on("content:replace", () => {
      scroll();
    });

    window.addEventListener("scroll", () => {
      scroll();
    });

    setTimeout(() => {
      i.animate = true;
    }, 1600);
  },
  toggleMenu() {
    if (this.isShop) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  },
  openMenu() {
    this.isShop = true;
    document.body.style.overflow = "hidden";
  },
  closeMenu() {
    this.isShop = false;
    document.body.style.overflow = "auto";
  },
});
